module.exports = __webpack_public_path__ + "static/media/Iconcretesection.3facfb66.svg";